import React from 'react';
import PropTypes from 'prop-types';

const NoMatch = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.344"
    height="14.461"
    viewBox="0 0 17.344 14.461"
    className={className}
  >
    <path
      d="M-6.07-7.156l1.016-1.3.5.32c1.141.727,3.3,2.867,3.3,4.563V.25A1.152,1.152,0,0,0,0,1.555,1.152,1.152,0,0,0,1.25.25V-3.578c0-1.7,2.141-3.836,3.3-4.562L5-8.422l.9,1.234c.469.656,1.227.4,1.492-.469l1.227-3.93a.945.945,0,0,0-.93-1.281l-4.109-.039c-.922-.016-1.367.633-.906,1.273l.844,1.172-.281.18a9.636,9.636,0,0,0-3.211,3.5H-.023a9.842,9.842,0,0,0-3.211-3.5l-.258-.172.813-1.039c.477-.617.055-1.281-.867-1.3l-4.117-.1a.933.933,0,0,0-.961,1.242l1.078,3.969C-7.3-6.812-6.57-6.531-6.07-7.156Z"
      transform="translate(8.672 12.907)"
      fill={fill}
    />
  </svg>
);

NoMatch.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default NoMatch;
